module.exports = __webpack_public_path__ + "img/icon_about_01.7c9e46a6.png";